import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const ContentWrapper = styled.div`
    display:grid;
    grid-template-columns: 1fr 300px;
    font-size: 16px;
    position: relative;
    max-height: 91vh;
    padding: 0 var(--padding) 80px var(--padding);
`;


export const SearchContainer = styled.div`
    display:flex;
    grid-column: 1 / span 2;
    padding-bottom: 16px;

    input{
        margin-left: auto;
        width:100%;
        max-width: 420px;
        outline:none;
        border-radius: 4px;
        border: 1px solid #aaaaaa;
        padding:6px 12px;
    }

    svg{
        width:16px;
        path{
            fill:#979797;
        }
    }
`;


export const StudentContainer = styled.div<{length?:number}>`
    display:grid;
    grid-template-columns: minmax(334px, auto) 1fr;
    grid-template-rows: repeat(${props => props.length?props.length:"7"}, 50px);
    width:calc(100%);
    border-right: 1px solid #bbbbbb;
    height:calc(91vh - 49px);
    overflow: auto;
    position: relative;

    > div:nth-of-type(1){
        position: sticky;
        top:0px;
        left:0;
        background:#f5f5f5;
        z-index: 3;
    }
    > div:nth-of-type(2){
        position: sticky;
        top:0px;
        right:0;
        background:#f5f5f5;
        z-index: 3;
    }

    ::-webkit-scrollbar {
        width: 12px;
    }
    ::-webkit-scrollbar-track {
        background: #e9e9e9;
        border-top: 1px solid #bbbbbb;
        border-bottom: 1px solid #bbbbbb;
        border-left: 1px solid #bbbbbb;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 0.815rem;
        background-color: #b9b9b9;
    }
`;

export const Student = styled.div<{selected?:boolean}>`
    display:flex;
    align-items: center;
    gap: 10px;
    border-top: 1px solid #bbbbbb;
    padding:6px 0 6px 20px;
    background:${props => props.selected?"#fff":"transparent"};
    cursor: pointer;

    :nth-of-type(2n){
        padding-left:40px;
    }
`;

export const ImageWrapper = styled.div<{big?:boolean}>`
    height:${props => props.big?"56px":"34px"};
    width:${props => props.big?"56px":"34px"};
    position: relative;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
    border-radius: 100%;
    
    img{
        width:100%;
        height:100%;
        object-fit: cover;
        border-radius: 100%;
        overflow:hidden;

    }
    > div {
        border-radius: 100%;
    }

    ${mq(Devices.mobile)}{
        width:80px;
        height:80px;

        left:unset;
        transform: unset;
    }
`;

export const GaurdianEdit = styled.div`
    border-top: 1px solid #bbbbbb;
    position: relative;
    padding: 20px 0 20px 0;

    > span{
        font-weight: 500;
        font-size: 18px;
        display:block;
        padding-left: 30px; 
        padding-bottom: 14px;
        padding-right: 100px;
    }
`;

export const GaurdianContent1 = styled.div`
    border-top: 1px solid #bbbbbb;
    padding-top:20px;
    padding-left: 20px;

    hr{
        margin-bottom: 16px;
    }
    
    > div:nth-of-type(1){
        display:flex;
        align-items: center;
        gap:14px;
        margin-bottom: 16px;
        span{
            font-weight: 500;
        }
    }
`;

export const AssignedContainer = styled.div`
    width:100%;
    display:flex;
    flex-direction: column;
    align-items: start;
    gap:4px;
    margin-top: 30px;

    > div{
        display:flex;
        align-items:center;
        gap:14px;
    }

    svg{
        width:20px;
    }
    div:nth-of-type(2) svg{
        width: 20px !important;
    }
`;

export const GaurdianContent2 = styled.div`
    border-top: 1px solid #bbbbbb;
    padding-top:30px;
    padding-left: 30px;
    
    
    svg{
        width:100%;
    }

    p{
        margin: 30px 0;
        text-align: center;
        font-size: 18px;
    }

    button{
        background:#2a848e;
        padding:8px 14px;
        border-radius: 4px;
        color:#fff;
        margin: 0 auto;
        display:block;

        :hover{
            background:#2f939e;
        }
    }
`;

export const PopupContainer = styled.div`
    min-width: 500px;
    position: relative;
    padding:30px;
    background:#fefefe;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
    font-size: 16px;

    h2{
        font-size: 22px;
        font-weight: 600;

    }

    > div{
        display:flex;
        align-items: center;
        gap: 10px;
        padding-right: 10px;
        :nth-of-type(1){
            padding:10px 0 ;
        }
        > svg{
            margin-left: auto;
            cursor: pointer;
            path{
                fill:#FA505E;
            }
        }
    }

    > div > div{

        display:flex;
        align-items:center;
        gap:14px;
        svg{
            width:20px;
        }
    }


    select{
        width:100%;
        border-radius: 4px;
        background-color: #ebebeb;
        border:none;
        padding:4px 12px;
        margin-top: 6px;
        box-shadow: inset 0 0 4px rgba(0,0,0,0.25);
        outline:none;
        cursor: pointer;
    }
    
`;


export const CloseButton = styled.button`
    position: absolute;
    top:40px;
    right:30px;
    svg{
        width:14px;
        path{
            fill:#c7c7c7;
        }
    }
`;

export const Button = styled.button`
    background:#2a848e;
    padding:8px 14px;
    border-radius: 4px;
    color:#fff;
    display:block;
    margin-left: auto;
    margin-top: 40px;
    min-width: 100px;
    display:flex;
    align-items: center;
    justify-content: center;
    gap:8px;
    transition: all 0.2s ease-in-out;

    svg{
        width:16px;
        path{
            fill:#fff;
        }
    }

    :hover{
        background:#2f939e;
    }
`;

export const IconContent = styled.div<{trans?:boolean}>`
    background: ${props => props.trans?"transparent":"#fff"};
    font-size: 0;
    box-shadow: 0 0 4px ${props => props.trans?"rgba(0,0,0,0)":"rgba(0,0,0,0.15)"};
    padding:8px;
    border-radius: 100%;
    
    svg{
        path{
            fill:#2f939e;
        }
    }
`;



